import { useLocation } from 'react-router-dom';
import { TabsContainer } from '@/components/TabView/Tabs';

type Props = {
  paths?: {
    details: string;
    entities: string;
    files: string;
  };
};

export const ProjectTabViewContainer = ({
  paths = {
    details: `details`,
    entities: `entities`,
    files: `files`,
  },
}: Props) => {

  const location = useLocation();

  const currentTab = [
    paths.files,
    paths.details,
    paths.entities,
  ].find((tab) => location.pathname.endsWith(`/${tab}`));

  const items = [
    {
      label: 'Entities',
      value: paths.entities,
      to: paths.entities,
    },
    {
      label: 'Files',
      value: paths.files,
      to: paths.files,
    },
    {
      label: 'Details',
      value: paths.details,
      to: paths.details,
    },
  ];

  return (
    <TabsContainer currentTab={currentTab} items={items} />
  );
};